import { render, staticRenderFns } from "./base-query-ranking-modal.component.vue?vue&type=template&id=1ffe07c8&scoped=true"
import script from "./base-query-ranking-modal.component.vue?vue&type=script&lang=ts"
export * from "./base-query-ranking-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./base-query-ranking-modal.component.vue?vue&type=style&index=0&id=1ffe07c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffe07c8",
  null
  
)

export default component.exports